export default {
  //region access_app
  addAccessAppPermission(state) {
    state.user.permissions.push('access_app')
  },
  removeAccessAppPermission(state) {
    if (state.user.permissions.includes('access_app')) {
      console.log('case ok')
      state.user.permissions.splice(
        state.user.permissions.indexOf('access_app'),
        1
      )
    }
  }
  //endregion
}
